import { useSelector } from 'react-redux';
import { Field, NumericInput, RadioGroup, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { MaximumDensityFrom } from './types';
import ReImportButton from '../../../Core/ReImportButton';
import React from 'react';

let TheoreticalMaximumDensitySectionBase: React.FC<IWorksheetComponent> = ({
  createWorksheetSelector,
}): JSX.Element => {
  const maximumDensityFrom: string = useSelector(createWorksheetSelector!('MaximumDensityFrom'));

  const maximumTheoreticalDensityIsEditable: boolean = ![
    MaximumDensityFrom.None.toString(),
    MaximumDensityFrom.MixDesign.toString(),
  ].includes(maximumDensityFrom);

  const importedFromMixDesign: boolean = MaximumDensityFrom.MixDesign === maximumDensityFrom;

  return (
    <ListFieldSection>
      <FieldSet>
        <Field
          input={<RadioGroup />}
          name="MaximumDensityFrom"
          freeEntry={true}
          freeEntryLabel="Other"
          freeEntryMaxLength={255}
          options={[
            { label: 'None', value: MaximumDensityFrom.None },
            { label: 'Client Provided', value: MaximumDensityFrom.ClientProvided },
            { label: 'Mix Design', value: MaximumDensityFrom.MixDesign },
          ]}
        />
      </FieldSet>

      <FieldSet visible={maximumTheoreticalDensityIsEditable}>
        <Field input={<NumericInput />} name="MaximumLabDensity" />
      </FieldSet>

      <FieldSet visible={importedFromMixDesign}>
        <Field input={<TextOutput />} name="ImportedAsphaltMix" />
        <ReImportButton name="ImportedAsphaltMixSource" />
        <Field input={<TextOutput />} name="MaximumLabDensity" />
        <ReImportButton name="ImportedMaximumLabDensitySource" />
      </FieldSet>
    </ListFieldSection>
  );
};

const TheoreticalMaximumDensitySection = withInjectedProps(TheoreticalMaximumDensitySectionBase);
export { TheoreticalMaximumDensitySection };
export default TheoreticalMaximumDensitySection;
